<template>
<div>
    <trademark-objection-to-us-report></trademark-objection-to-us-report>
</div>
</template>

<script>
export default {}
</script>
